<!--首页-->
<template>
	<div class="khdxz_content" id="homeCont">
		<div class="ucontent">
			<div class="header">
				<a class="logo" :href="'http://www.xubei.com/?channel=' + channel">
					<img src="/static/images/khdxz/logo.png" />
				</a>
				<ul class="menu">
					<li style="border-top: 3px solid #fff">
						<a :href="'http://www.xubei.com/?channel=' + channel" target="_blank">网站首页</a>
					</li>
					<li>
						<a
							:href="'http://new.xubei.com/shopList.html?gameid=1494&userId=472474&channel=' + channel"
							target="_blank"
						>
							租帐号
						</a>
					</li>
					<li><a :href="'http://user.xubei.com/goods_released&channel=' + channel" target="_blank">发布帐号</a></li>
				</ul>
			</div>

			<div class="main_content">
				<div class="leftcn">
					<div class="t1">租号客户端</div>
					<div class="t2">虚贝游戏上号器</div>
					<a class="downbtn" href="http://download.xubei.com/?f=shq_toufang_sem" target="_blank">
						<img src="/static/images/khdxz/downbtn.png" />
					</a>
					<div class="tips">全面兼容Win10、及Win8、Win7、XP等操作系统</div>
					<a
						:href="'http://www.xubei.com/help/servicesDetail.htm?menuSecondId=38&channel=' + channel"
						class="qus"
						target="_blank"
					>
						上号器常见问题解决方法
					</a>
				</div>
				<div class="rightcn"><img src="/static/images/khdxz/tu.png" /></div>
			</div>

			<div class="hot_game">
				<div class="hot_game_tit">
					<div class="rm">
						热门游戏
						<span>Hot games</span>
					</div>
				</div>

				<div class="swiper-container">
					<div class="swiper-wrapper">
						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=1518&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r8.png" />
								<div class="title">GTA5</div>
								<div class="hao">
									<span>冒险</span>
									<span>动作</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=1851&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r9.png" />
								<div class="title">反恐精英OL</div>
								<div class="hao">
									<span>战争</span>
									<span>枪战</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=588&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r4.png" />
								<div class="title">逆战</div>
								<div class="hao">
									<span>战争</span>
									<span>机甲</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=302&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r1.png" />
								<div class="title">穿越火线</div>
								<div class="hao">
									<span>多人</span>
									<span>射击</span>
								</div>
							</a>
						</div>
						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=245&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r2.png" />
								<div class="title">英雄联盟</div>
								<div class="hao">
									<span>多人</span>
									<span>射击</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=1494&userId=472474&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r3.png" />
								<div class="title">绝地求生</div>
								<div class="hao">
									<span>竞技</span>
									<span>策略</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=1109&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r5.png" />
								<div class="title">王者荣耀</div>
								<div class="hao">
									<span>多人对战</span>
									<span>竞技</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=1838&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r6.png" />
								<div class="title">QQ飞车</div>
								<div class="hao">
									<span>大型多人</span>
									<span>竞技</span>
								</div>
							</a>
						</div>

						<div class="swiper-slide">
							<a
								class="swiper-game"
								:href="'http://new.xubei.com/shopList.html?gameid=587&channel=' + channel"
								target="_blank"
							>
								<img src="/static/images/khdxz/r7.png" />
								<div class="title">守望先锋</div>
								<div class="hao">
									<span>射击游戏</span>
									<span>战争</span>
								</div>
							</a>
						</div>
					</div>
					<div class="swiper-pagination"></div>
				</div>

				<div class="game-zuhao">
					<div class="item">
						<div class="icon"><img src="/static/images/khdxz/icon1.png" /></div>
						<div class="cn">
							<div class="c1">便捷租号</div>
							<div class="c2">客户端直接选号租号</div>
						</div>
					</div>

					<div class="item">
						<div class="icon"><img src="/static/images/khdxz/icon2.png" /></div>
						<div class="cn">
							<div class="c1">一键上号</div>
							<div class="c2">登录简单快捷</div>
						</div>
					</div>

					<div class="item">
						<div class="icon"><img src="/static/images/khdxz/icon3.png" /></div>
						<div class="cn">
							<div class="c1">订单续费</div>
							<div class="c2">时间不够不过瘾，订单加时继续玩</div>
						</div>
					</div>
				</div>

				<div class="footer-cn">
					<div class="tit">虚贝游戏上号器</div>
					<a href="http://download.xubei.com/?f=shq_toufang_sem" class="download" target="_blank">
						<img src="/static/images/khdxz/downbtn.png" />
					</a>
					<div class="copyright">
						Copyright © 2015-2016 杭州诸相网络科技有限公司 (www.xubei.com) 版权所有 浙ICP备15
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
export default {
	name: 'khdxz',
	components: {},
	data: function () {
		return {
			channel: this.$route.query.channel || ''
		};
	},
	mounted() {
		var mySwiper = new Swiper('.swiper-container', {
			slidesPerView: 6,
			spaceBetween: 30,
			freeMode: true,
			autoplay: true,
			pagination: {
				el: '.swiper-pagination',
				clickable: true
			}
		});
	},
	methods: {}
};

var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?cdea94c5bc45d355e2a3ab8d8664de0d';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.khdxz_content {
	width: 100%;
	height: 100%;
	background: #fff url(/static/images/khdxz/bg.png) no-repeat;
	background-size: 100% 100%;
	.ucontent {
		width: 1200px;
		margin: 0 auto;
		color: #fff;
		overflow: hidden;
		.header {
			overflow: hidden;
			.logo {
				float: left;
				margin-top: 24px;
				display: block;
				img {
					width: 132px;
					height: 60px;
				}
			}

			.menu {
				float: right;
				overflow: hidden;
				font-size: 16px;
				li {
					float: left;
					margin-left: 50px;
					border-top: 3px solid transparent;
					a {
						display: block;
						color: #fff;
						padding-top: 36px;
					}
				}
			}
		}

		.main_content {
			overflow: hidden;
			.leftcn {
				float: left;
				.t1 {
					font-size: 60px;
				}
				.t2 {
					font-size: 36px;
					padding: 27px 0 40px 0;
				}
				float: left;
				margin-top: 124px;
				.downbtn {
					display: block;
					img {
						width: 243px;
						height: 74px;
					}
				}
				.tips {
					color: #999999;
					font-size: 16px;
					padding: 20px 0 56px 0;
				}
				.qus {
					text-decoration: underline;
					color: #333333;
					font-size: 16px;
				}
			}

			.rightcn {
				float: right;
				img {
					width: 591px;
					height: 429px;
					margin-top: 70px;
				}
			}
		}

		.hot_game {
			margin-top: 125px;
			.hot_game_tit {
				overflow: hidden;
				margin-bottom: 25px;
				.rm {
					float: left;
					border-left: 3px solid #00e8ff;
					font-size: 24px;
					color: #212121;
					padding-left: 5px;
					span {
						font-size: 16px;
						color: #999999;
						padding-left: 8px;
					}
				}
			}

			.swiper-container {
				.swiper-wrapper {
					height: 215px;
				}
				.swiper-slide {
					.swiper-game {
						box-shadow: 1px -1px 6px #d4d8dc;
						border: 1px solid #efefef;
						text-align: center;
						display: block;
						padding: 20px 0;
						border-radius: 10px;
						background: #fff;
						img {
							width: 120px;
							height: 58px;
							display: block;
							margin: 0 auto;
						}
						.title {
							font-size: 14px;
							color: #333333;
							padding: 20px 0;
						}

						.hao {
							span {
								color: #999999;
								border: 1px solid #999999;
								padding: 1px 5px;
								border-radius: 10px;
								margin: 0 5px;
							}
						}
					}
					a:hover {
						border: 1px solid #00e8ff;
					}
				}
			}

			.game-zuhao {
				overflow: hidden;
				padding: 48px 0;
				.item {
					width: 33.33%;
					float: left;
					overflow: hidden;
					.icon {
						float: left;
						img {
							width: 155px;
							height: 160px;
						}
					}
					.cn {
						padding-left: 168px;
						padding-top: 70px;
						.c1 {
							font-size: 19px;
							color: #333333;
							font-weight: bold;
							margin-bottom: 3px;
						}
						.c2 {
							font-size: 15px;
							color: #999999;
						}
					}
				}
			}
		}

		.footer-cn {
			text-align: center;
			.tit {
				font-size: 36px;
				color: #212121;
				margin-bottom: 10px;
			}
			.download {
				display: block;
				img {
					width: 243px;
					height: 74px;
				}
			}
			.copyright {
				font-size: 12px;
				color: #999;
				padding: 30px 0 25px 0;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/khdxz.vue